import {OrderItemInput} from "./OrderItemInput";

export class UpdateInStructureOrderInput {
    constructor(
        public readonly orderId: string,
        public readonly customerNotes?: string,
        public readonly items?: OrderItemInput[]
    ) {
    }
}